import { useState, useCallback } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

import { ThemeProvider }  from './contexts/ThemeContext';
import { ToastProvider, useToast } from './contexts/ToastContext';
import { useWebSocket }   from './hooks/useWebSocket';
import Sidebar             from './components/Sidebar';
import Home                from './pages/Home';
import Battles             from './pages/Battles';
import BattleDetail        from './pages/BattleDetail';
import PlayerProfile       from './pages/PlayerProfile';
import Top50               from './pages/Top50';
import Search              from './pages/Search';
import Disconnects         from './pages/Disconnects';
import ClanBattleStats     from './pages/ClanBattleStats';
import GlobalClans         from './pages/GlobalClans';
import Icon                from './components/Icon';

function AppInner() {
  const [mobileOpen, setMobileOpen]   = useState(false);
  const [wsConnected, setWsConnected] = useState(false);
  const [refreshKey, setRefreshKey]   = useState(0);
  const { toast } = useToast();

  useWebSocket(useCallback((msg) => {
    if (msg.type === 'connected') setWsConnected(true);
    if (msg.type === 'standings_update') {
      toast('Battle data updated — refreshing…', 'info');
      setRefreshKey(k => k + 1);
    }
  }, [toast]));

  return (
    <BrowserRouter>
      <div className="layout">
        <Sidebar
          wsConnected={wsConnected}
          mobileOpen={mobileOpen}
          onMobileClose={() => setMobileOpen(false)}
        />

        <div className="main">
          {/* Mobile header */}
          <div className="mobile-header">
            <button className="btn-icon" aria-label="Open navigation" onClick={() => setMobileOpen(o => !o)}><Icon name="menu" /></button>
            <span className="mobile-title">Battleboard</span>
            <div className={`ws-dot${wsConnected ? ' connected' : ''}`} />
          </div>

          {/* Page routes */}
          <Routes>
            <Route path="/"                    element={<Home refreshKey={refreshKey} />} />
            <Route path="/battles"             element={<Battles />} />
            <Route path="/battle/:id"          element={<BattleDetail refreshKey={refreshKey} />} />
            <Route path="/player/:robloxId"    element={<PlayerProfile />} />
            <Route path="/top50"               element={<Top50 />} />
            <Route path="/search"              element={<Search />} />
            <Route path="/search/:query"       element={<Search />} />
            <Route path="/disconnects"         element={<Disconnects />} />
            <Route path="/clan-stats"          element={<ClanBattleStats />} />
            <Route path="/global-clans"        element={<GlobalClans />} />
            <Route path="*"                    element={<Home refreshKey={refreshKey} />} />
          </Routes>
        </div>

        {/* Mobile sidebar overlay */}
        {mobileOpen && (
          <div
            style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 99 }}
            onClick={() => setMobileOpen(false)}
          />
        )}
      </div>
    </BrowserRouter>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <AppInner />
      </ToastProvider>
    </ThemeProvider>
  );
}
